import {useDispatch} from "react-redux";

import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";


import {changeFilter} from "../../../actions/FilterActions";
import {getEstacoesTrabalho, getLoginLogoutsHoje, getProcessos} from "../../../actions/i4Actions";
import POperadores from "./POperadores";
import {getOperadores} from "../../../actions/stationActions";


const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap'

    },

    operadores: {
        alignContent: 'flex-start'
    }
}));

const today = new Date();


const PainelTVOperadores = ( props ) => {
    const classes = useStyles();
    const { setTitulo } = props;

    const [show, setShow] = useState(false);


    const dispatch = useDispatch();

    console.log("Paineloperadores const.")

    useEffect( () => {
        //console.log("dispatch getFotografia")
        //console.log("hoje", today,  today.toISOString(), today.toDateString(), today.toUTCString())


        dispatch(getOperadores())
        dispatch(getProcessos());

        props.setTitulo("OPERADORES - NESTE MOMENTO");

    }, []);


    useEffect( () => {
        //console.log("dispatch getFotografia")
        //console.log("hoje", today,  today.toISOString(), today.toDateString(), today.toUTCString())


        dispatch(getOperadores())
        dispatch(getProcessos());
        dispatch(getLoginLogoutsHoje());


        props.setTitulo("LOGINS");

    }, [props.contador]);


    return (
        <React.Fragment>
            <Grid container className={classes.mainGrid}>
                <Grid item container xs={12} sm={12} lg={12} xl={12}>
                      <POperadores/>
                </Grid>
            </Grid>
        </React.Fragment>
    )

}
export default (PainelTVOperadores);


